import { Avatar, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { useCurrentViewPropertySession } from 'src/hooks/use-current-view-property-session';
import Gender from '~components/gender';
import Typography from '~components/typography';
import { PortraitDefault } from '~svg-components';
import hexToRGBA from '~utils/hex-to-rgba';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      ...theme.flex.crossCenter,
      padding: '0px 12px 8px 16px',
      minHeight: '60px',
      backgroundColor: theme.colors.white,
      cursor: 'pointer',
      width: '184px',
      '&:hover $nameGender': {
        color: theme.colors.brandAction,
      },
    },

    avatar: {
      width: 40,
      height: 40,
      marginRight: 12,
    },

    avatarFile: {
      width: 'inherit',
      height: 'inherit',
    },

    avatarBorder: {
      border: `1px solid ${hexToRGBA(theme.colors.grey66, 0.16)}`,
    },

    defaultAvatar: {
      width: '100%',
      height: '100%',
    },

    nameGender: {
      flex: 1,
      marginTop: -2,
    },
  }),
  { name: 'StudentCardRecentlyViewed' }
);

function StudentCardRecentlyViewed({ student }) {
  const classes = useStyles();

  const { id, fullName, gender } = student;

  const [
    {
      currentViewProperty: { id: propertyId },
    },
  ] = useCurrentViewPropertySession();

  const openStudentDetailPage = () => {
    const studentDetailsUrl = queryString.stringifyUrl({
      url: '/student/student-details/personal-information',
      query: { studentId: id, propertyId },
    });
    window.open(studentDetailsUrl);
  };

  const renderStudentAvatar = () => {
    const src = student.profilePhotoFileUuid;
    const avatarSrc = src ? `${process.env.REACT_APP_FILE_SERVICE_URL}/files/${src}` : undefined;
    return (
      <div className={classes.avatar}>
        <Avatar
          src={avatarSrc}
          className={classNames(classes.avatarFile, {
            [classes.avatarBorder]: avatarSrc,
          })}
        >
          <PortraitDefault className={classes.defaultAvatar} />
        </Avatar>
      </div>
    );
  };

  const renderStudentNameGender = () => (
    <div className={classes.nameGender}>
      <Typography variant="body1" themeColor="dark" className={classes.nameGender}>
        {fullName} <Gender type={gender} style={{ verticalAlign: 'middle' }} />
      </Typography>
    </div>
  );

  return (
    <div
      className={classes.root}
      onClick={() => {
        openStudentDetailPage();
      }}
    >
      {renderStudentAvatar()}
      {renderStudentNameGender()}
    </div>
  );
}

StudentCardRecentlyViewed.prototype = {
  student: PropTypes.object.isRequired,
};

export default StudentCardRecentlyViewed;
